import React from 'react';
import PropTypes from 'prop-types';
import userImage from '../../../assets/img/icons/user.svg';
import { getProfileImage } from '../../../utils';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../../constants/queryKey';
import CircleSpinner from '../../../assets/svg/CircleSpinner';
import { QUERY_STALE_TIME } from '../../../constants';
export const ImageWithFallback = ({ src, height, width, className, alt, ...props }) => {
    const { data, isFetching } = useQuery({
        queryKey: [QUERY_KEYS.USER_IMAGE, src],
        queryFn: () => getProfileImage({ profileImg: src }),
        placeholderData: userImage,
        enabled: !!src,
        staleTime: QUERY_STALE_TIME.THIRTY_MIN
    });

    return (
        <>
            {isFetching ? (
                <CircleSpinner size='1.5rem' />
            ) : (
                <img
                    className={className || ''}
                    src={data || userImage}
                    height={height}
                    width={width}
                    onError={(e) => (e.target.src = userImage)}
                    alt={alt || ''}
                    {...props}
                />
            )}
        </>
    );
};

ImageWithFallback.propTypes = {
    src: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    className: PropTypes.string,
    alt: PropTypes.string,
};

ImageWithFallback.defaultProps = {
    src: null,
};
